import { Box, Grid, Typography } from '@mui/material';
import React, { FC } from 'react';
import { WithdrawFundsSummaryDto } from 'app/interfaces/dto';
import { useStyles } from '../TransactionSummary.styles';
import { FormatCurrency, FormatCurrencyType } from 'shared/components/Format/Currency';
import { MoneyDto } from 'app/interfaces/dto/money.dto';
import { WithdrawSingleCurrencyCryptoSummary } from './WithdrawSingleCurrencyCryptoSummary';

interface ComponentProps {
  summary: WithdrawFundsSummaryDto;
  source: MoneyDto;
  title: string;
}

export const WithdrawFundsSummary: FC<ComponentProps> = ({ summary, source, title }) => {
  const { classes } = useStyles();

  if ('sourceAmountCrypto' in summary) {
    return <WithdrawSingleCurrencyCryptoSummary summary={summary} />;
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.row}>
        <Typography>{title}</Typography>
      </Box>
      <Box className={classes.row}>
        <Grid container rowSpacing={1}>
          <Grid item xs={8} sm={10}>
            <Typography>Withdraw Amount</Typography>
          </Grid>
          <Grid item xs={4} sm={2} textAlign="right">
            <FormatCurrency {...source} type={FormatCurrencyType.Crypto} />
          </Grid>
          <Grid item xs={8} sm={10}>
            <Typography>Processing Fee</Typography>
          </Grid>
          <Grid item xs={4} sm={2} textAlign="right">
            <FormatCurrency {...summary.platformFee} type={FormatCurrencyType.Crypto} />
          </Grid>
          {summary.destinationAmount?.currency ? (
            <>
              <Grid item xs={8} sm={10}>
                <Typography>Destination Amount</Typography>
              </Grid>
              <Grid item xs={4} sm={2} textAlign="right">
                <FormatCurrency {...summary.destinationAmount} type={FormatCurrencyType.Crypto} />
              </Grid>
            </>
          ) : null}
          <Grid item xs={8} sm={10}>
            <Typography>New Balance</Typography>
          </Grid>
          <Grid item xs={4} sm={2} container rowSpacing={1} justifyContent="flex-end">
            {summary.newBalances.map((balance) => (
              <Grid item sm={12} key={balance.currency + balance.amount} textAlign="right">
                <FormatCurrency {...balance} type={FormatCurrencyType.Crypto} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
